import { proxiedPost, proxiedGet } from '@/core/http/api-client'
import { getMemberCalls2Url } from '@/core/http/http-helper'
import { getCurrentApiEnvironment } from '@/core/store/environment.store'

const HYDRA_NAMESPACE = {
    live: 'https://hydra.unicity.net/customers',
    dev: 'https://hydraqa.unicity.net/customers'
} as const

export interface LoginApiResponse {
    baId: string
    href: string
    userStatus: string
    allowCredit?: { enable: boolean }
    loginData?: { token: string }
    tokenHydra?: string
    checkToken?: { token: string }
    error?: string
    message?: string
}

export const loginApi = async (username: string, password: string, countryCode: string): Promise<LoginApiResponse> => {
    const env = getCurrentApiEnvironment()
    const namespace = HYDRA_NAMESPACE[env]
    const isQa = env === 'dev' ? '&isQa=1' : ''
    const url = getMemberCalls2Url(`etlV2/loginTokens?ushopCountryCode=${countryCode}&platform=feelgreat${isQa}`)
    return proxiedPost<LoginApiResponse>(url, {
        type: 'base64',
        value: btoa(`${username}:${password}`),
        namespace
    })
}

export const checkGeoAllow = (baId: string, countryCode: string): Promise<{ isAllow?: boolean }> => {
    const url = getMemberCalls2Url(`geoLocation/checkAllow/?platform=feelGreat&countryCode=${countryCode}&baId=${baId}`)
    return proxiedGet<{ isAllow?: boolean }>(url)
}

export const checkAcceptLanguage = (baId: string, countryCode: string): Promise<{ isAllow?: boolean }> => {
    const url = getMemberCalls2Url('validate/check-accept-language')
    return proxiedPost<{ isAllow?: boolean }>(url, {
        acceptLanguage: navigator.language,
        baId,
        countryCode,
        platform: 'feelGreat'
    })
}

export const extractToken = (response: LoginApiResponse): string | null => {
    if (response.loginData?.token) return response.loginData.token
    if (response.checkToken?.token) return response.checkToken.token
    if (response.tokenHydra) return response.tokenHydra.replace('Bearer ', '')
    return null
}
